import { ALERT_BAR_DISMISS, ALERT_BAR_UPDATE } from '~/redux/actions/types'

export const dismissAlertBar = () => {
  return {
    type: ALERT_BAR_DISMISS,
  }
}

export const updateAlertBar = (notification) => {
  return {
    type: ALERT_BAR_UPDATE,
    payload: {
      notification,
    },
  }
}
